<template lang="pug">
  div.channel-list
    div.header
      span.title 参与渠道({{mediaType}})
      div.sort
        span 排序方式：
        a(:class="{active: sidx === 'indexInfluence'}" @click.prevent="changeSidx('indexInfluence')") 渠道重要性
        a(:class="{active: sidx === 'articleCount'}" @click.prevent="changeSidx('articleCount')") 参与次数
    div.lists(v-if="!loading")
      div.list(v-for="(l, i) in list" :key="i")
        div.info
          div.details
            img(:src="l.headUrl")
            div.name
              p {{l.nick}}
              div.tags
                div.tag(v-for="t in l.indexTag" :key="t.key")
                  img(:src="t.icon")
                  span {{t.tag}}
          div.join
            span {{l.articleCount}}
            p 参与次数
        div.articles(:style="{height: `${l.expand ? l.articles.length * 26 - 10 : l.height}px`}")
          div.article(v-for="(art, $i) in l.articles")
            a.article_title(:href="art.url" target="_blank") {{$i + 1}}、{{art.title || art.content}}
            span {{art.publishTime}}
        div.expand(v-if="l.articles.length > 3")
          span(@click.prevent="expand(l)") {{l.expand ? '收起' : '展开'}}
    div.lists(v-else)
      Loading
</template>

<script>
import Loading from '../components/Loading'
import bus from './bus'
export default {
  name: 'ChannelList',
  components: {
    Loading
  },
  data () {
    return {
      // 媒体类型
      mediaType: '央级'
    }
  },
  // 接收数据
  mounted () {
    bus.$on('mediaTypeSend', mType => {
      this.mediaType = mType.slice(0, 2)
    })
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    changeSidx: {
      type: Function,
      required: true
    },
    sidx: {},
    loading: {}
  },
  methods: {
    expand (l) {
      let boolean = !l.expand
      this.$set(l, 'expand', boolean)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/common';
.channel-list {
  height: 100%;
  flex: 2;
  margin-right: 14px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    padding: 14px 0;
    font-size: 12px;
    color: #666;
    .sort {
      display: flex;
      align-items: center;
      a {
        margin-left: 20px;
        &.active {
          color: #3989cb;
        }
      }
    }
  }
  .lists {
    height: calc(100% - 66px);
    overflow-y: auto;
    @include scrollBar;
    .list {
      padding: 24px;
      background-color: #fafafa;
      &:nth-of-type(even) {
        background-color: #f5f5f5;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .details {
          display: flex;
          align-items: center;
          img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin-right: 20px;
          }
          .name {
            p {
              font-weight: bold;
            }
            .tags {
              display: flex;
              align-items: center;
              margin-top: 14px;
              .tag {
                padding: 3px 10px;
                margin-right: 24px;
                background-color: #eeeeee;
                color: #666;
                font-size: 12px;
                display: flex;
                align-items: center;
                border-radius: 12px;
                img {
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  margin-right: 12px;
                }
              }
            }
          }
        }
        .join {
          color: #f87653;
          font-size: 18px;
          text-align: center;
          p {
            font-size: 12px;
            color: #999;
            margin-top: 8px;
          }
        }
      }
      .articles {
        margin-top: 20px;
        overflow: hidden;
        transition: all 0.2s;
        .article {
          font-size: 12px;
          margin-bottom: 10px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .article_title {
            color: #666;
            display: block;
            display: -webkit-box;
            /* ! autoprefixer: off */
            -webkit-box-orient: vertical;
            /* ! autoprefixer: on */
            -webkit-line-clamp: 1;
            overflow: hidden;
            max-width: 800px;
            &:hover {
              color: #3989cb;
              cursor: pointer;
            }
          }
          span {
            min-width: 150px;
            text-align: right;
          }
        }
      }
      .expand {
        text-align: right;
        span {
          color: #3989cb;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventChannel/ChannelList.vue